export default __webpack_public_path__ + "static/media/Contact.a0710b01.svg";